import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import IconHeader from "./IconHeader";
import Person from "../images/person.svg?react";
import TextField from "./TextField";

const requiredInputText = (
	<FormattedMessage
		id="direct.validation.requiredTextField"
		description="Text for obligatorisk felt"
		defaultMessage="Required field"
	/>
);

const invalidInputText = (
	<FormattedMessage
		id="direct.validation.invalidInput"
		description="Text for ugyldig feltverdi"
		defaultMessage="Invalid input"
	/>
);

function PersonInfo(props) {
	const customer = props.customer ?? {};
	const canShowEmailAndPhone = props.canShowEmailAndPhone ?? true;
	const fieldState = props.fieldState ?? {};
	const validation = props.validation ?? {};

	const handleFieldChange = useCallback(
		(field, value) => props.onChange(props.name, field, value),
		[props]
	);

	return (
		<div>
			<div className="section section-header-wrapper">
				<IconHeader
					text={
						<FormattedMessage
							id="direct.personinfo.iconheader.omdeg.text"
							description="Text for iconheader"
							defaultMessage="About you"
						/>
					}
					icon={<Person />}
				/>
			</div>
			<div className="divider" />
			<div className="personInfo">
				<table>
					<tbody>
						<tr>
							<th>
								<FormattedMessage
									id="direct.personinfo.table.th.navn"
									description="Text table th"
									defaultMessage="Name"
								/>
							</th>
							<td>{customer.CustomerName}</td>
						</tr>
						<tr>
							<th>
								<FormattedMessage
									id="direct.personinfo.table.th.addresse"
									description="Text table th"
									defaultMessage="Address"
								/>
							</th>
							<td>{customer.CustomerAddress}</td>
						</tr>

						{canShowEmailAndPhone ? (
							<>
								<tr>
									<th>
										<FormattedMessage
											id="direct.personinfo.table.th.tlf"
											description="Text table th"
											defaultMessage="Phone"
										/>
									</th>
									<td>{customer.CustomerMobile}</td>
								</tr>
								<tr>
									<th>
										<FormattedMessage
											id="direct.personinfo.table.th.epost"
											description="Text table th"
											defaultMessage="E-mail"
										/>
									</th>
									<td>{customer.CustomerEmail}</td>
								</tr>
							</>
						) : null}
						{customer.CoCustomerName &&
						customer.CoCustomerName.trim().length > 0 ? (
							<tr>
								<th>
									<FormattedMessage
										id="direct.personinfo.table.th.medlåntaker"
										description="Text table th"
										defaultMessage="Co-applicant"
									/>
								</th>
								<td>{customer.CoCustomerName}</td>
							</tr>
						) : null}
					</tbody>
				</table>
			</div>
			{customer.CustomerType !== "Private" ? (
				<>
					<div className="section section-header-wrapper">
						<IconHeader
							text={
								<FormattedMessage
									id="direct.personinfo.iconheader.contactDetails.text"
									description="Text for iconheader"
									defaultMessage="Contact details"
								/>
							}
							icon={<Person />}
						/>
					</div>
					<div className="divider" />
					<div className="personInfo">
						<div className="row">
							<TextField
								className="col s12 m6 input-box-wrapper left-align"
								box
								name="ContactPersonName"
								value={fieldState.ContactPersonName || ""}
								label={
									<FormattedMessage
										id="direct.customer.textfield.contactPersonName.label"
										description="Label for contact persons anme"
										defaultMessage="Name of contact person"
									/>
								}
								onChange={(name, value) =>
									handleFieldChange(name, value ? value : "")
								}
								errorText={
									validation.ContactPersonName === false
										? fieldState.ContactPersonName
											? invalidInputText
											: requiredInputText
										: null
								}
							/>
						</div>
						<div className="row">
							<TextField
								className="col s12 m6 input-box-wrapper left-align"
								box
								name="ContactPersonPhone"
								value={fieldState.ContactPersonPhone || ""}
								label={
									<FormattedMessage
										id="direct.customer.textfield.contactPersonPhone.label"
										description="Label for contact persons phone number"
										defaultMessage="Contact persons phone number"
									/>
								}
								onChange={handleFieldChange}
								errorText={
									validation.ContactPersonPhone === false
										? fieldState.ContactPersonPhone
											? invalidInputText
											: requiredInputText
										: null
								}
							/>
							<TextField
								className="col s12 m6 input-box-wrapper left-align"
								box
								name="ContactPersonEmail"
								value={fieldState.ContactPersonEmail || ""}
								label={
									<FormattedMessage
										id="direct.customer.textfield.contactPersonEmail.label"
										description="Label for contact perosns email"
										defaultMessage="Contact persons email"
									/>
								}
								onChange={handleFieldChange}
								errorText={
									validation.ContactPersonEmail === false
										? fieldState.ContactPersonEmail
											? invalidInputText
											: requiredInputText
										: null
								}
							/>
						</div>
					</div>
				</>
			) : null}
		</div>
	);
}

PersonInfo.displayName = "PersonInfo";

export default PersonInfo;
